import React from "react";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";

const Seniority = ({ value, setValue, error }) => {
    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const seniorityOptions = ["Junior", "Mid", "Senior"];

    return (
        <FormControl fullWidth error={!!error}>
            <InputLabel id="demo-multiple-chip-label">Seniority</InputLabel>
            <Select
                labelId="seniority-select-label"
                label="Seniority"
                id="seniority-select"
                data-testid="seniority-select"
                onChange={handleChange}
                variant="outlined"
                defaultValue=""
                value={value}
                fullWidth
            >
                {seniorityOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText error>{error || " "}</FormHelperText>
        </FormControl>
    );
};

export default Seniority;
